// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fa4664cf","239":"6453c12a","455":"6d5abef1"}[chunkId] + ".chunk.js";
};